import React, { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
  publishedTime?: string;
  modifiedTime?: string;
  author?: string;
  section?: string;
  tags?: string[];
}

const SEO: React.FC<SEOProps> = ({
  title = "The Brief - Namibia's Leading Business News E-Paper Archive | Daily Financial News",
  description = "Access The Brief's complete digital e-paper archive. Namibia's #1 business and financial news publication. Daily economic updates, market analysis, and business insights from Windhoek.",
  keywords = "Namibia business news, The Brief e-paper, Windhoek financial news, Namibian economy, business newspaper Namibia, digital newspaper, financial journalism, economic news Africa",
  image = "https://epaper.thebrief24.com/logo.png",
  url = "https://epaper.thebrief24.com/",
  type = "website",
  publishedTime,
  modifiedTime,
  author = "The Brief",
  section = "Business News",
  tags = ["Namibia", "Business", "Finance", "Economy", "Windhoek"]
}) => {
  useEffect(() => {
    document.title = title;

    const updateMetaTag = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    const updatePropertyMetaTag = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    updateMetaTag('author', author);

    updatePropertyMetaTag('og:title', title);
    updatePropertyMetaTag('og:description', description);
    updatePropertyMetaTag('og:image', image);
    updatePropertyMetaTag('og:url', url);
    updatePropertyMetaTag('og:type', type);

    updatePropertyMetaTag('twitter:title', title);
    updatePropertyMetaTag('twitter:description', description);
    updatePropertyMetaTag('twitter:image', image);
    updatePropertyMetaTag('twitter:url', url);

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = url;
  }, [title, description, keywords, author, image, url, type]);

  return null;
};

export default SEO;
